import type {FocusEventHandler, MouseEventHandler} from 'react';
import React from 'react';
import {IconButton} from '@mui/material';
import type {ButtonBaseTypeMap} from '@mui/material/ButtonBase';
import type {IconButtonTypeMap} from '@mui/material/IconButton';
import {Icon} from '../icons';
import {FlexBox} from '../layout';
import {Text} from '../text';

type Props = {
  label?: string;
  id?: string;
  onBlur?: FocusEventHandler;
  color?: IconButtonTypeMap['props']['color'];
  onClick?: MouseEventHandler;
  iconButtonTouchRippleProps?: ButtonBaseTypeMap['props']['TouchRippleProps'];
};

const sxTitle = {
  pl: 0,
};

export const AddButton: React.FC<Props> = ({
  label,
  id,
  onBlur,
  onClick,
  color,
  iconButtonTouchRippleProps,
}) => {
  return (
    <FlexBox center left horizontal onBlur={onBlur}>
      <IconButton id={id} color={color} size="small" onClick={onClick}>
        <Icon icon={'Add'} />
      </IconButton>

      <IconButton
        id={id}
        tabIndex={-1}
        color={color}
        size="small"
        sx={sxTitle}
        disableRipple
        TouchRippleProps={iconButtonTouchRippleProps}
        onClick={onClick}>
        <Text kind="primary" variant="button">
          {label}
        </Text>
      </IconButton>
    </FlexBox>
  );
};
